import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    Title,
    ArcElement,
    DoughnutController,
    LineElement,
    PointElement,
    Filler,
    LineController,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { forwardRef } from 'react';
import { getChartDefaultsOptions, BarChartProps } from './utils/chartDefaults';
import ResponsiveChartContainer from './ResponsiveChartContainer';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    Title,
    ArcElement,
    DoughnutController,
    LineElement,
    PointElement,
    Filler,
    LineController
);

const BarChart = forwardRef<ChartJS<'bar'> | undefined, BarChartProps>(
    function BarChart(
        {
            data,
            options,
            plugins,
            testId,
            fixedHeight = false,
            minHeight = 300,
            maxHeight = 700,
        },
        ref?: React.ForwardedRef<ChartJS<'bar'> | undefined>
    ) {
        const defaultOptions = options || getChartDefaultsOptions(fixedHeight);

        if (fixedHeight) {
            return (
                <ResponsiveChartContainer
                    minHeight={minHeight}
                    maxHeight={maxHeight}
                    testId={`${testId ?? 'bar-chart'}-container`}
                >
                    <Bar
                        ref={ref}
                        data={data}
                        options={{
                            ...defaultOptions,
                            maintainAspectRatio: false,
                        }}
                        plugins={plugins}
                        data-testid={testId ?? 'bar-chart'}
                    />
                </ResponsiveChartContainer>
            );
        }

        return (
            <Bar
                ref={ref}
                data={data}
                options={defaultOptions}
                plugins={plugins}
                data-testid={testId ?? 'bar-chart'}
            />
        );
    }
);

export default BarChart;
